import React from "react";
import { Link } from "react-router-dom";

const TermsServices = () => {
  return (
    <div className="flex justify-center">
      <p className="underline font-semibold text-center">
        Read our{" "}
        <Link to="/settings-terms-policy" className="text-gray-700">
          Terms
        </Link>{" "}
        and{" "}
        <Link to="/settings-terms-policy#section-15" className="text-gray-700">
          Privacy Policy
        </Link>
      </p>
    </div>
  );
};

export default TermsServices;
